import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';

import { getAll } from '../../api/module/jobs';
import { catchExceptionSRate } from '../../utils/helpers/helpers';

const EmployeeRolForm = ({ form, onFinish }) => {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    getAllJobs();
  }, []);

  const getAllJobs = async () => {
    try {
      const response = await getAll();
      setJobs(response.data.results);
    } catch (error) {
      catchExceptionSRate(error);
    }
  };

  return (
    <Form onFinish={onFinish} form={form} layout="vertical">
      <Form.Item
        name="cargo"
        label="Digite el cargo del empleado dentro de Corpoeducación"
        rules={[{ required: true }]}
      >
        <Select allowClear showSearch optionFilterProp="label" options={jobs} />
      </Form.Item>
      <Form.Item
        name="depende_de"
        label="¿De quién depende?"
        rules={[{ required: true }]}
      >
        <Select allowClear showSearch optionFilterProp="label" options={jobs} />
      </Form.Item>
      <Form.Item
        name="le_reportan"
        label="¿Quienes le reportan?"
        rules={[{ required: true }]}
      >
        <Select
          allowClear
          showSearch
          optionFilterProp="label"
          mode="multiple"
          options={jobs}
        />
      </Form.Item>
    </Form>
  );
};

export default EmployeeRolForm;
